import { IAssetCategoryTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export const assetTypeQueryKey = 'asset-type';

export function useAssetType(
    assetTypeId?: number,
    queryOptions?: UseQueryOptions<IAssetCategoryTypeResponse | undefined>
) {
    return useQuery({
        queryKey: [assetTypeQueryKey, assetTypeId],

        queryFn:
            assetTypeId !== undefined
                ? () => sdClient.getAssetClassificationType({ typeId: assetTypeId })
                : skipToken,

        ...queryOptions,
    });
}

export function invalidateAssetType(assetTypeId: number) {
    queryClient.invalidateQueries({
        queryKey: [assetTypeQueryKey, assetTypeId],
    });
}
